const steps = [
  {
    title: 'Marque uma Consulta Gratuita',
    description:
      'Não há compromisso, só uma conversa aberta para entender como podemos ajudar o seu negócio a crescer.',
    imageUrl: '/images/homepage/illustrations/1.webp',
  },
  {
    title: 'Avaliar as Suas Necessidades',
    description:
      'Cada empresa tem a sua essência. O nosso trabalho é entendê-la e transformá-la em resultados concretos.',
    imageUrl: '/images/homepage/illustrations/2.webp',
  },
  {
    title: 'Implementar Soluções',
    description:
      'Nós não oferecemos soluções genéricas. Cada estratégia é desenhada para as suas necessidades específicas, com um plano de ação claro para o futuro.',
    imageUrl: '/images/homepage/illustrations/3.webp',
  },
  {
    title: 'Monitorizar e Crescer',
    description:
      'O nosso trabalho não termina na implementação. Estamos ao seu lado para otimizar continuamente e garantir que a sua jornada digital seja um sucesso.',
    imageUrl: '/images/homepage/illustrations/4.webp',
  },
];

const HowItWorks = () => {
  return (
    <section className="hiw section">
      <div className="wrapper wrapper--large">
        <h2 className="wrapper__title">Como Funciona</h2>

        <div className="row col-4">
          {steps.map((step, index) => (
            <div key={index} className="col card">
                <img className="card__banner" alt="" src={step.imageUrl} />
                <h3 className="card__title h5">{step.title}</h3>
                <p className="card__description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;